// extracted by mini-css-extract-plugin
module.exports = {"Podcast":"podcast_Podcast__8h5OY","hero":"podcast_hero__7MUCw","podcastCards":"podcast_podcastCards__Sirg0","podcastCard":"podcast_podcastCard__F85K9","img":"podcast_img__gZYMl"};